export const normalizeFilename = (filename) => {
    return filename.replaceAll(/[^a-z0-9.]/gi, '')
}
